var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-table",
    {
      ref: "multipleTable",
      staticClass: "customized-table",
      attrs: {
        data: _vm.data,
        "tree-props": _vm.treeProps,
        "row-key": _vm.rowKey,
        "expand-row-keys": _vm.expandRowKeys,
        "default-expand-all": _vm.defaultExpandAll,
        height: _vm.height,
        "max-height": _vm.maxHeight,
      },
    },
    [
      _c("yxt-table-column", {
        attrs: {
          width: _vm.columnWidth,
          "show-overflow-tooltip": true,
          prop: "name",
          "class-name": "customize-table-column",
          label: _vm.$t(_vm.columnLabel),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (scope) {
                return [
                  _vm.selection &&
                  (!scope.row[_vm.treeProps.children] ||
                    scope.row[_vm.treeProps.children].length === 0)
                    ? [
                        _vm.radioModel &&
                        _vm.data.findIndex(function (item) {
                          return item[_vm.rowKey] === scope.row[_vm.rowKey]
                        }) === -1
                          ? _c(
                              "div",
                              {
                                staticClass: "flex align-items-center",
                                on: {
                                  click: function ($event) {
                                    _vm.switchSelected(
                                      _vm.selected.findIndex(function (sel) {
                                        return (
                                          sel[_vm.rowKey] ===
                                          scope.row[_vm.rowKey]
                                        )
                                      }) === -1,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _vm.getCheckStatus(scope.row)
                                  ? _c("yxt-svg", {
                                      staticClass: "mr16 hand color-primary",
                                      class: {
                                        disabled: _vm.getDisabledStatus(
                                          scope.row
                                        ),
                                      },
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "remote-url":
                                          _vm.gwnlMediaDomain + "/gwnl/pc/svg",
                                        "icon-class": "checked2",
                                      },
                                    })
                                  : _c("yxt-radio", {
                                      staticClass: "customized-radio mb3",
                                      attrs: {
                                        value: false,
                                        disabled: _vm.getDisabledStatus(
                                          scope.row
                                        ),
                                      },
                                    }),
                              ],
                              1
                            )
                          : _c("yxt-checkbox", {
                              staticClass: "customized-checkbox",
                              attrs: {
                                disabled: _vm.getDisabledStatus(scope.row),
                                name: scope.row[_vm.rowKey],
                                value: _vm.getCheckStatus(scope.row),
                              },
                              on: {
                                change: function (checked) {
                                  return _vm.switchSelected(checked, scope.row)
                                },
                              },
                            }),
                      ]
                    : _vm._e(),
                  _c("span", {}, [_vm._v(_vm._s(scope.row.name))]),
                  _vm._t("nameSuffix", null, { row: scope.row }),
                  scope.row[_vm.treeProps.children] &&
                  _vm.getCheckboxValue(scope.row)
                    ? _c("yxt-svg", {
                        staticClass: "ml8",
                        attrs: {
                          width: "20px",
                          height: "20px",
                          "remote-url":
                            _vm.gwnlMediaDomain +
                            "/gwnl/pc/media/images/pc_svg/position",
                          "icon-class": "check",
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }